module.exports = __webpack_public_path__ + "img/Trophy Cup Table45.02588cc9.jpg";